import * as React from 'react';

export const BlankQuizIcon = (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 11C16 8.79086 17.7909 7 20 7H46.3431C47.404 7 48.4214 7.42143 49.1716 8.17157L63.8284 22.8284C64.5786 23.5786 65 24.596 65 25.6569V67C65 69.2091 63.2091 71 61 71H20C17.7909 71 16 69.2091 16 67V11Z"
      fill="#E4FBFF"
    />
    <path
      d="M11 6C11 3.79086 12.7909 2 15 2H41.3431C42.404 2 43.4214 2.42143 44.1716 3.17157L58.8284 17.8284C59.5786 18.5786 60 19.596 60 20.6569V62C60 64.2091 58.2091 66 56 66H15C12.7909 66 11 64.2091 11 62V6Z"
      stroke="#0099C7"
      strokeWidth="2"
    />
    <path
      d="M35 51.25V33.75"
      stroke="#0099C7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.5 42.75L44 42.75"
      stroke="#0099C7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43 3.20711C43 2.76165 43.5386 2.53857 43.8536 2.85355L59.1464 18.1464C59.4614 18.4614 59.2383 19 58.7929 19H47C44.7909 19 43 17.2091 43 15V3.20711Z"
      stroke="#0099C7"
      strokeWidth="2"
    />
  </svg>
);
